<template>
  <router-view v-slot="{ Component }">
    <transition name="page-fade" mode="out-in" appear>
      <component :is="Component" />
    </transition>
  </router-view>
</template>

<style lang="scss">
// Import Main styles for this application
@import 'styles/style';

.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

// Transisi antar halaman utama (login <-> layout)
.page-fade-enter-active,
.page-fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.page-fade-enter-from {
  opacity: 0;
  transform: translateY(8px);
}
.page-fade-leave-to {
  opacity: 0;
}
</style>
